import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import NavHeading from './NavHeading';
import Social from './Social';
import styles from './footer.module.scss';

const legalLinks = [
  {title: 'Privacy', href: 'https://www.teamgantt.com/privacy-policy/'},
  {title: 'Security', href: 'https://www.teamgantt.com/security/'},
  {title: 'Terms', href: 'https://www.teamgantt.com/terms/'},
];

const Footer = ({footerLinks}) => (
  <footer className={styles.Footer}>
    <div className={styles.Footer__inner}>
      <div className={styles.Footer__top}>
        <a
          aria-label="TeamGantt home"
          className={styles.Footer__logo}
          href="https://www.teamgantt.com/"
        >
          <Logo className={styles.Footer__logoImg} />
        </a>
        <div className={styles.Footer__nav}>
          {footerLinks.map(({heading, links}, i) => (
            <div key={`footer-links-${i}`}>
              <NavHeading text={heading} />
              <ul>
                {links.map(({title, href}, j) => (
                  <li className={styles.Footer__navItem} key={`link-${i}-${j}`}>
                    <a className={styles.Footer__link} href={href}>
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.Footer__bottom}>
        <p className={styles.Footer__copyright}>
          &copy; {new Date().getFullYear()} TeamGantt
        </p>
        <ul className={styles.Footer__legal}>
          {legalLinks.map(({title, href}) => (
            <li key={title}>
              <a className={styles.Footer__link} href={href}>
                {title}
              </a>
            </li>
          ))}
        </ul>
        <Social />
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  footerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          href: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js